namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemExDTsForm {
        PmGroupId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PluCode: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        ItemType: Serenity.IntegerEditor;
        StyleCode: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        SupplCode: Serenity.StringEditor;
    }

    export class Adv05ItemExDTsForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.Adv05ItemExDTs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Adv05ItemExDTsForm.init)  {
                Adv05ItemExDTsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(Adv05ItemExDTsForm, [
                    'PmGroupId', w0,
                    'PmType', w1,
                    'PluCode', w0,
                    'SkuCode', w0,
                    'PluShortDesc', w0,
                    'ItemType', w1,
                    'StyleCode', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplCode', w0
                ]);
            }
        }
    }
}
